import React from "react";
import { Card, Progress } from "antd";
import SelectOption from "components/select/SelectOption";



const EmployeeProgressCard = ( props ) => {
  
  const {name, role, date, department, completed, total, employeeId, overallResult } = props;

  return (
          <Card className="flex flex-col gap-6 rounded-2xl border-2 border-purple-200 gradient white ">
            <div className="justify-between items-start flex flex-col md:flex-row md:items-center justify-between grid grid-cols-2">
              <div className="flex items-center space-x-3">
                <div className="border-2 border-purple-200 flex px-4 py-3 size-16 justify-center rounded-full gradient emerald text-white text-[20px] font-medium">
                    {(name ? name.split(" ").map((n) => n[0]).join("") : "")} JD
                </div>
                <div className="flex-1">
                  <h1 className="text-[24px] font-semibold mb-1 dark:text-white"> 
                    {/* {name}  */} John Doe
                    </h1>
                  <p className="text-[14px] text-muted-foreground mb-1 dark:text-white">role</p>
                  <div className="flex items-center text-gray-600 text-sm gap-2">
                    <span className="text-xs status-indicator normal dark:text-white dark:bg-white/40">
                      department
                    </span>
                    <span className="text-xs status-indicator normal dark:text-white dark:bg-white/40">
                      employeeId
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex space-x-3 items-end flex-col gap-2 w-full">
                <span className="text-gray-600 text-xs dark:text-gray-100">Review Period</span>
                <div>
                  <SelectOption
                    placeholder="Q1 2025"
                    style={{ width: 128 }}
                    size="medium"
                    options={[
                      {label:"Q1 2025", value: 0},
                      {label:"Q2 2025", value: 1},
                      {label:"Q3 2025", value: 2},
                      {label:"Q4 2025", value: 3},
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="mt-6">
              <div className="flex items-center justify-between">
                <p className="text-[13px] font-medium dark:text-white">Review Progress</p>
                <p className="text-[13px] text-gray-100">{completed} / {total} categories completed</p>
              </div>
              <Progress
                percent={((Number(completed) || 0) / (Number(total) || 1)) * 100}
                showInfo={false} 
                strokeColor="#22c55e"
                trailColor="rgba(34, 197, 94, 0.2)"
                strokeWidth={8} 
                strokeLinecap="round"
              />
            </div>
          </Card>
);
};

export default EmployeeProgressCard;